import React from 'react'
import Link from 'next/link'
import { Sparkles, ChevronDown } from 'lucide-react'
import { Button } from '@components/ui/button'
import TooltipDropdown from '../../../components/TooltipDropdown'

const CreateButton = ({ createOptions, handleButtonClick }) => {
  const trigger = (
    <Button variant="gradient" className="hover:opacity-90 transition-opacity">
      <Sparkles size={16} />
      Create <ChevronDown size={14} className="ml-1" />
    </Button>
  )

  return (
    <TooltipDropdown trigger={trigger} caretStyle={{ marginLeft: '60%' }}>
      <div className="py-1 min-w-[140px]">
        {createOptions.map((option, index) =>
          option.href ? (
            <Link key={`create-option-${index}`} href={option.href} passHref>
              <div className="flex items-center gap-2 px-4 py-2 cursor-pointer hover:bg-gray-50 dark:hover:bg-zinc-800/50 transition-colors duration-200">
                {option.icon &&
                  React.createElement(option.icon, { className: 'w-4 h-4 text-zinc-700 dark:text-zinc-300' })}
                <span className="text-sm text-zinc-900 dark:text-zinc-100">{option.label}</span>
              </div>
            </Link>
          ) : (
            <div
              key={`create-option-${index}`}
              className="flex items-center gap-2 px-4 py-2 cursor-pointer hover:bg-gray-50 dark:hover:bg-zinc-800/50 transition-colors duration-200"
              onClick={() => {
                handleButtonClick(option)
              }}
            >
              {option.icon &&
                React.createElement(option.icon, { className: 'w-4 h-4 text-zinc-700 dark:text-zinc-300' })}
              <span className="text-sm text-zinc-900 dark:text-zinc-100">{option.label}</span>
            </div>
          )
        )}
      </div>
    </TooltipDropdown>
  )
}

export default CreateButton
